<template>
  <div class="chatsContent">
    <div class="chatsBox">
      <div class="top">
        <div class="left">
          <div class="chats_title">
            <span>销售产品概览</span>
          </div>
          <div class="canvas-stage" ref="overview" v-loading="loading1" element-loading-background="rgba(255,255,255,0.3)"></div>
          <el-button type="text" class="float-right" @click="leftButton">显示明细</el-button>
        </div>
        <div class="right">
          <div class="chats_title">
            <span>月均销量数量分布</span>
          </div>
          <div class="canvas-stage" ref="distribute" v-loading="loading2" element-loading-background="rgba(255,255,255,0.3)"></div>
          <el-button type="text" class="float-right" @click="rightButton">显示明细</el-button>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="chats_title">
            <span>{{ headerText }}</span>
          </div>
          <div class="canvas-stage" ref="price" v-loading="loading3" element-loading-background="rgba(255,255,255,0.3)"></div>
          <div class="float-right">
            <el-switch
              v-model="value1"
              active-text="月均过百"
              active-color="#16507B"
              inactive-color="#16507B"
              inactive-text="全品类"
              style="position: relative; top: -1px; margin-right: 15px"
            >
            </el-switch>
            <el-button type="text" @click="priceButton" style="color: #fff">显示明细</el-button>
          </div>
          <div class="float-left" v-if="value1">
            <span>{{ this.priceData.productTotal || 0 }}</span>
            个销售单品,月均销售过百的有
            <span>{{ this.priceData.hundredProductNum || 0 }}</span
            >个,占比
            <span>{{ (this.priceData.proportion || 0) + '%' }}</span>
          </div>
        </div>
        <div class="canvas-item right">
          <div class="chats_title">
            <span>年度销量分布</span>
          </div>
          <div class="canvas-stage" ref="monthlyaverage" v-loading="monthlyaverageFlag" element-loading-background="rgba(255,255,255,0.3)"></div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="previousYear + '销售产品上新概览'"
      :visible.sync="dialogFormVisibleLeft"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="dialog-box" style="margin: 0 20px; height: 400px">
        <div class="canvas-stage" ref="leftDialog" v-loading="loading4"></div>
      </div>
    </el-dialog>
    <el-dialog title="月均销售量分布" :visible.sync="dialogFormVisibleRight" :modal-append-to-body="false" :close-on-click-modal="false" width="70%">
      <div class="dialog-box" style="margin: 0 20px; height: 400px">
        <div class="canvas-stage" ref="rightDialog" v-loading="loading5"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import leftMixin from './left.mixin';
import leftDialogMixin from './leftDialog.mixin';
import rightDialogMixin from './rightDialog.mixin.js';
import rightMixin from './right.mixin';
import peiceMixin from './price.mixin';
import monthlyaverage from './monthlyaverage.mixin';
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
export default {
  mixins: [leftMixin, leftDialogMixin, rightMixin, rightDialogMixin, peiceMixin, monthlyaverage, pagePathMixin],
  name: 'YearBehavior',
  data() {
    return {
      value1: true,
      monthlyaverageFlag: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      dialogFormVisibleLeft: false,
      dialogFormVisibleRight: false,
      year: moment().year(),
      priceData: '',
      totalYear: moment().year() - 1 + '年',
      time: {
        startTime: moment().startOf('year').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
      },
      leftData: [],
      rightData: [],
      headerText: '月均销售过百的产品价格段分布',
    };
  },
  watch: {
    value1(nv, ov) {
      this.init3();
      if (nv) {
        this.headerText = '月均销售过百的产品价格段分布';
      } else {
        this.headerText = '全品类价格段分布';
      }
    },
  },
  computed: {
    previousYear() {
      let item = JSON.parse(JSON.stringify(this.time));
      let startTime = item.startTime ? item.startTime.slice(0, 4) : '';
      let endTime = item.endTime ? item.endTime.slice(0, 4) : '';
      if (startTime == endTime) {
        return startTime;
      } else {
        return '';
      }
    },
  },
  mounted() {},
  methods: {
    handleCategoryChange(year) {
      this.time.startTime = year + '-01-01';
      this.time.endTime = year + '-12-31';
      this.$emit('timeupdate', [year + '-01-01', year + '-12-31']);
      this.init();
      this.init2();
      this.init3();
    },
    resetForm() {
      this.time = {
        startTime: moment().startOf('year').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
      };
      this.yearChange();
    },
    init() {
      this.loading1 = true;
      this.$q.goodsAnalysis
        .soldProducts({
          data: {
            type: '2',
            ...this.time,
          },
        })
        .then((res) => {
          console.log(res);
          this.leftData = res.data;
          this.render_left(res.data);
        })
        .finally((_) => {
          this.loading1 = false;
        });
    },
    leftDialog() {
      this.render_leftDialog(this.leftData);
    },
    init2(data) {
      this.loading2 = true;
      this.$q.goodsAnalysis
        .monthSaleChart({
          data: {
            type: '2',
            ...this.time,
          },
        })
        .then((res) => {
          this.rightData = res.data;
          this.render_right(res.data, data);
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    rightDialog(data) {
      setTimeout(() => {
        this.render_rightDialog(this.rightData, data);
      }, 200);
    },

    init3() {
      this.loading3 = true;
      this.$q.goodsAnalysis
        .productPrice({
          data: {
            type: '2',
            priceType: this.value1 ? '1' : '2',
            ...this.time,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.priceData = res.data;
          this.render_price(res.data, this.value1);
        })
        .finally((_) => {
          this.loading3 = false;
        });
    },
    leftButton() {
      this.openSubPage({
        path: '/proBehaviorYear',
        query: {
          activeName: 'yaerNewProductOverview',
          ...this.time,
        },
      });
    },
    rightButton() {
      console.log(this.time);
      this.openSubPage({
        path: '/proBehaviorYear',
        query: {
          activeName: 'monthSalesVolumes',
          ...this.time,
        },
      });
    },
    priceButton() {
      if (this.value1) {
        this.openSubPage({
          path: '/proBehaviorYear',
          query: {
            activeName: 'ProductSalesVolume',
            ...this.time,
          },
        });
      } else {
        this.openSubPage({
          path: '/proBehaviorYear',
          query: {
            activeName: 'priceDistribution',
            ...this.time,
          },
        });
      }
    },
    yearChange(time) {
      this.time = time;
      if (this.time.endTime) {
        this.totalYear = '';
      }
      this.init();
      this.init2();
      this.init3();
      this.getYearData();
    },
    getYearData() {
      this.monthlyaverageFlag = true;
      this.$q.goodsAnalysis
        .productSaleNum()
        .then((res) => {
          this.render_distribute(res.data);
        })
        .finally((_) => {
          this.monthlyaverageFlag = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.chatsContent {
  overflow-y: auto;
  height: calc(100% - 57px)
  width: 100%
  padding: 0
  overflow-x: hidden
  // box-sizing: border-box;
}
.chatsBox {
  margin: 5px
  padding: 10px 5px
  width: calc(100% - 20px)
  height: calc(100% - 30px)
  background: url('../../../../assets/images/refundKanban_img/center_bg.png') no-repeat center 0px;
  background-size: 100% 100%;
  position: relative
  z-index: 2

  .top {
    margin: 5px 5px 0 5px;
    overflow: hidden;
    position: relative;

    .left {
      width: 50%;
      height: calc(100% - 10px);
      padding-top: 10px
      float: left;
      position: relative;
      background: url('../../../../assets/images/refundKanban_img/content_bg.png') no-repeat center 0px;
      background-size: 100% 100%;
    }

    .right {
      width: calc(50% - 5px);
      margin-left: 5px;
      height: calc(100% - 10px);
      padding-top: 10px
      float: left;
      position: relative;
      background: url('../../../../assets/images/refundKanban_img/content_bg.png') no-repeat center 0px;
      background-size: 100% 100%;
    }
  }

  .bottom {
    margin: 5px 5px 0px 5px;
    position: relative;
    display: flex;
      .left {
        width: 60%;
        position: relative;
        height: calc(100% - 20px);
        padding-left: 0;
        padding-top: 10px;
        margin-bottom: 5px;
        margin-right: 5px
        background: url('../../../../assets/images/refundKanban_img/content_bg.png') no-repeat center 0px;
        background-size: 100% 100%;
      }
      .right {
        width: 40%;
        height: calc(100% - 20px);
        position: relative
        padding-left: 0;
        padding-top: 10px;
        margin-bottom: 5px;
        background: url('../../../../assets/images/refundKanban_img/content_bg.png') no-repeat center 0px;
        background-size: 100% 100%;
      }
  }
}

.chatsBox .canvas-stage {
  position: absolute
  left: 0
  top: 0
  // background: #fff;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  overflow: hidden
}

.dialog-box .canvas-stage {
  width: 100%;
  height: 100%;
}

.float-right {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 22;
  color: #fff
}

.float-left {
  position: absolute;
  left: 10px;
  top: 50px;
  z-index: 22;

  color: #999999;

  span {
    color: #E6A23C;
  }
}

.float-right-year {
  position: absolute;
  line-height: 29px;
  right: 70px;
  top: 8px;
  z-index: 22;
}

>>> .form-date-picker .el-date-editor {
  width: 123px !important;
}


>>> .el-form-item {
  margin-bottom: 0;
}
.el-form--inline .el-form-item {
  margin:  0
}

.chats_title {
  height: 34px
  line-height: 28px
  width: 200px
  background: url('../../../../assets/images/refundKanban_img/content_header.png') no-repeat center 0px;
  background-size: 100% 100%;
  position: relative
    span {
      position: absolute
      width: 360px
      left: 20%
      font-family: JDLangZhengTi;
      font-weight: 400;
      font-size: 20px;
      color: #FFFFFF;
    }
}

>>> .el-switch__label{
  color: #fff
  font-family: PingFangSC;
}

>>> .el-switch__core:after {
  background-color: #15E1FF
}
</style>
<style scoped>
@media screen and (min-width: 1920px) {
  .float-left {
    font-size: 15px;
  }
  .top {
    height: 50%;
  }
  .bottom {
    height: calc(50% - 5px);
  }
}
/* @media screen and (max-width: 1919px) {
  .float-left {
    font-size: 12px;
  }
  .top {
    height: 45%;
  }
  .bottom {
    height: calc(55% - 5px);
  }
} */
@media screen and (max-width: 1919px) {
  .header_left {
    flex: 4;
  }
  .container .header .header_left .text {
    font-size: 26px;
    margin-top: 10px;
  }
  ::v-deep .el-form--inline .el-form-item__label {
    font-size: 16px;
  }
  .chatsBox {
    height: 700px;
  }
  .float-left {
    font-size: 12px;
  }
  .top {
    height: 45%;
  }
  .bottom {
    height: calc(55% - 5px);
  }
}
</style>
